import { types } from '../../../types/types';

export const loginGereValidaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.VALIDAACESSO:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const loginGerecodigoResetSenhaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.CODIGO_RESETSENHA:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const loginGerecodigoValidaCadReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.CODIGO_VALIDACAD:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const loginGerevalidaCadReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.VALIDACAD:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const pesquisaloginGereReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.PESQUISA:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;
        default:
            result = state;
            break;
    }
    return result;
}

export const atualizaloginGereReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.ATUALIZALOGIN:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;  
        default:
            result = state;
            break;
    }
    return result;
}

export const atualizaloginDadosGereReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.LOGINGERENCIAMENTO.ATUALIZALOGINDADOS:
            result = action.payload;
            break;
        case types.LOGINGERENCIAMENTO.INICIALOGIN:
            result = {};
            break;  
        default:
            result = state;
            break;
    }
    return result;
}